module.exports = __webpack_public_path__ + "img/style_cy_m.ecffaaec.png";